import { IRevenueSpendByAccountOfferSpendDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountOfferSpendDetailsTableLang: IRevenueSpendByAccountOfferSpendDetailsTableLang = {
	revenue_spend_by_account_offer_spend_details_table: {
		column_id: 'ID_ru',
		column_date: 'Date_ru',
		column_amount: 'Amount_ru',
		column_percent: 'Percent, %_ru',
		column_offer: 'Offer_ru',
		column_scope: 'Scope_ru',
		column_notes: 'Notes_ru'
	}
}